import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "cn"

const calloutVariants = cva(
  "group/callout flex flex-col gap-2 rounded-none border-s-4 px-5 py-4 text-start data-[size=lg]:gap-2.5 data-[size=lg]:px-6 data-[size=lg]:py-5",
  {
    variants: {
      variant: {
        default: "border-primary bg-primary-50 dark:bg-primary-950/40",
        neutral: "border-greyscale-300 bg-muted/60 dark:border-greyscale-600",
        success: "border-success bg-success-50 dark:bg-success/10",
        destructive: "border-destructive bg-destructive/5 dark:bg-destructive/10",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Callout({
  className,
  variant = "default",
  size = "default",
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof calloutVariants> & { size?: "default" | "lg" }) {
  return (
    <div
      data-slot="callout"
      data-variant={variant}
      data-size={size}
      className={cn(calloutVariants({ variant }), className)}
      {...props}
    />
  )
}

function CalloutLabel({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      data-slot="callout-label"
      className={cn(
        "typo-overline text-muted-foreground group-data-[variant=default]/callout:text-primary-text group-data-[variant=destructive]/callout:text-destructive group-data-[variant=success]/callout:text-success",
        className
      )}
      {...props}
    />
  )
}

function CalloutContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="callout-content"
      className={cn(
        "typo-body-md text-pretty text-foreground group-data-[size=lg]/callout:typo-h6 group-data-[size=lg]/callout:leading-7",
        className
      )}
      {...props}
    />
  )
}

export { Callout, CalloutContent, CalloutLabel, calloutVariants }
